import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { importProvidersFrom } from '@angular/core';

import { NotifierModule } from 'angular-notifier';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routing'; 
import { customNotifierOptions } from './app/components/shared/conf.notifier';

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    provideRouter(routes),
    // ✅ Se importa NotifierModule con configuración
    importProvidersFrom(NotifierModule.withConfig(customNotifierOptions)),
  ],
});
